function init() {

  document.querySelectorAll('.mgmenu_m_drawer_row > button').forEach(element => {
    element.addEventListener('click', () => {
      document.querySelectorAll('.mgmenu_m_drawer_row > button').forEach(element2 => {
        if (element === element2) {
          if (element2.parentNode.classList.contains("active")) {
            element2.parentNode.classList.remove("active");
          } else {
            element2.parentNode.classList.add("active");
          }
        } else {
          element2.parentNode.classList.remove("active");
        }
      })
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", function() {
    init();
  });
} else {
  init();
}